export default __webpack_public_path__ + "static/media/grb.b2f66348.jpg";